import { toast } from "react-toastify";

import { useCustomerRequests } from "../../../api/grpc/customer/useCustomerRequests";
import { useCustomerPermissionsRequests } from "../../../api/grpc/permissions/useCutomerPermissionRequests";
import { useGlobalWorkingHours } from "../../../lib/hooks/useGlobalWorkingHours";
import { useAuthContext } from "../../../lib/context/Auth/AuthContext";

import { CustomerSettingsVariables } from "../../Organization/OrganizationSettings/InsightsCard/Insights/Insights";
import { defineBooleanValue } from "../../../lib/helpers/defineBooleanValue";

export const useWorkingHoursData = () => {
  const { loading, error, customerSettings, refetch } = useGlobalWorkingHours();
  const { updateCustomerSettings } = useCustomerRequests();
  const { getCustomerPermissions } = useCustomerPermissionsRequests();
  const { user, updateUser } = useAuthContext();

  const handleWorkingHours = async ({
    startTime,
    endTime,
    errorReportingEmail,
    meetingSpaceCostPerHr,
    currency,
    workingWeekDays,
    collectInsights,
    ssoEnable,
    disableDeskSimultaneous,
    showEventOrganizer,
    deskBookingDisabledForRoles,
    deskBookingEnabled,
    roomBookingDisabledForRoles,
    roomBookingEnabled,
    systemNotificationRecipientUserIds,
  }: CustomerSettingsVariables) => {
    try {
      if (!!customerSettings) {
        const shouldRefetchPermissions =
          (deskBookingEnabled !== undefined &&
            deskBookingEnabled !== customerSettings.deskBookingEnabled) ||
          (roomBookingEnabled !== undefined &&
            roomBookingEnabled !== customerSettings.roomBookingEnabled);

        await updateCustomerSettings({
          startTime: startTime || customerSettings.startTime,
          endTime: endTime || customerSettings.endTime,
          errorReportingEmail:
            errorReportingEmail || customerSettings.errorReportingEmail,
          meetingSpaceCostPerHr:
            meetingSpaceCostPerHr || customerSettings.meetingSpaceCostPerHr,
          currency: currency || customerSettings?.currency,
          workingWeekDays: workingWeekDays || customerSettings.workingWeekDays,
          collectInsights: defineBooleanValue(
            collectInsights,
            customerSettings.collectInsigths
          ),
          ssoEnable: defineBooleanValue(ssoEnable, customerSettings.ssoEnable),
          disableDeskSimultaneous: defineBooleanValue(
            disableDeskSimultaneous,
            customerSettings.disableDeskSimultaneous
          ),
          showEventOrganizer: defineBooleanValue(
            showEventOrganizer,
            customerSettings.showEventOrganizer
          ),
          deskBookingDisabledForRoles:
            deskBookingDisabledForRoles ||
            customerSettings.deskBookingDisabledForRoles,
          deskBookingEnabled:
            deskBookingEnabled ?? customerSettings.deskBookingEnabled,
          roomBookingDisabledForRoles:
            roomBookingDisabledForRoles ||
            customerSettings.roomBookingDisabledForRoles,
          roomBookingEnabled:
            roomBookingEnabled ?? customerSettings.roomBookingEnabled,
          systemNotificationRecipientUserIds:
            systemNotificationRecipientUserIds ||
            customerSettings.systemNotificationRecipientUserIds,
          crossOrgRoomCalendarEnabled:
            customerSettings.crossOrgRoomCalendarEnabled,
        });

        toast.success("Customer settings updated successfuly");
        refetch();

        if (
          shouldRefetchPermissions &&
          user?.customerid &&
          user?.claims?.user_id
        ) {
          try {
            const { response } = await getCustomerPermissions({
              customerID: user.customerid,
              accountID: user.claims.user_id,
            });

            updateUser({
              deskBookingEnabled: response.deskBookingEnabled,
              roomBookingEnabled: response.roomBookingEnabled,
            });
          } catch (permissionError) {
            console.error(permissionError);
          }
        }
        return;
      }
    } catch (error: any) {
      toast.error(
        error.message
          ? error.message
          : "Cannot set working hours, please try again"
      );
    }
  };

  return { loading, error, customerSettings, handleWorkingHours, refetch };
};
